"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const React = tslib_1.__importStar(require("react"));
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const Button_1 = tslib_1.__importDefault(require("../Button"));
const Icon_1 = tslib_1.__importDefault(require("../Icon"));
const Wrapper = styled_components_1.default.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Title = styled_components_1.default.div `
  text-align: center;
  color: ${({ theme }) => theme.inactiveColor};
  font-size: ${(0, polished_1.rem)(32)};
  font-weight: 500;
`;
const Spacer = styled_components_1.default.div `
  height: ${(0, polished_1.rem)(20)};
`;
const C = ({ className, icon, title, theme, onClickAction, actionLabel, }) => {
    return (React.createElement(Wrapper, { className: className },
        icon && React.createElement(Icon_1.default, { name: icon, size: "xxl", color: theme.inactiveColor }),
        icon && title && React.createElement(Spacer, null),
        title && React.createElement(Title, null, title),
        onClickAction && actionLabel && (React.createElement(React.Fragment, null,
            React.createElement(Spacer, null),
            React.createElement(Button_1.default, { primary: true, onClick: onClickAction }, actionLabel)))));
};
exports.default = (0, styled_components_1.withTheme)(C);
